/**
 * @name results.controller:successBoxes
 * @description
 * Controller for successBoxes directive. Load and insert appropriate images and
 * links to success boxes.
 */
export default function ($scope, CommonFunctions, $http, config, $timeout) {
    'ngInject';
    const baseImageUrl = 'https://www.rp-assets.com/furniture/bloodstock/';
    const imageExtension = '.gif';
    const breakpointMap = {
        extraNarrow: 1,
        narrow: 2,
        medium: 4,
        wide: 8,
        extraWide: 16
    };
    let link = null;
    let successBoxesList = [];

    /**
     * Set link for success boxes data
     * @param {number} breakpointId Id for current breakpoint
     */
    $scope.setLink = (breakpointId) => {
        /* eslint-disable */
        link = `${config.get('resultsPath')}/data/success-boxes/${$scope.raceId}/${breakpointId}.json`;
        /* eslint-enable  */
    };

    /**
     * Getter for link
     * @returns {string}
     */
    $scope.getLink = () => link;

    /**
     * Get appropriate property form object
     * @param {string} breakpoint Name of breakpoint
     * @returns {number} Breakpoint code
     */
    $scope.getCurrentBreakpoint = (breakpoint) => breakpointMap[breakpoint];

    /**
     * Getter for baseImageUrl
     * @returns {string}
     */
    $scope.getImageUrl = () => baseImageUrl;

    /**
     * Getter for imageExtension
     * @returns {string}
     */
    $scope.getImageExtension = () => imageExtension;

    /**
     * Set array of success boxes
     * @param {Array} array List of objects with success box info
     */
    $scope.setSuccessBoxesList = (array) => {
        successBoxesList = array.map($scope.setSuccessBoxesItem);
    };

    /**
     * Getter for successBoxesList
     * @returns {Array}
     */
    $scope.getSuccessBoxesList = () => successBoxesList;

    /**
     * Check if url is email or web address and replace the href attribute value
     * with the appropriate one.
     *
     * @param {Array} data
     * @returns
     */
    $scope.formatUrl = (data) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const urlRegex = /^(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\/.*)?$/;
        const urlPrefixRegex = /^https?:\/\//;

        // Note:
        // This is a mocked data for testing purposes,
        // because the issue with url missing https:// prefix is not reproducible on local environment.
        // the issue is JP-9327

        // const mockedData = [
        //     {
        //         name: 'was8499',
        //         url: 'http://www.voutesales.com'
        //     },
        //     {
        //         name: 'was8966',
        //         url: 'www.worsallgrange.com'
        //     },
        //     {
        //         name: 'was8421',
        //         url: 'liz.whitaker1@btconnect.com'
        //     }
        // ];

        return data.map((item) => {
            if (emailRegex.test(item.url)) {
                item.url = `mailto:${item.url}`;
            }

            if (urlRegex.test(item.url)) {
                item.url = urlPrefixRegex.test(item.url) ? `${item.url}` : `https://${item.url}`;
            }

            return item;
        });
    };

    /**
     * Helper function for map Array.map method. Form object with appropriate properties
     * @param {object} element Element from array
     * @returns {{image: string, url: string}}
     */
    $scope.setSuccessBoxesItem = (element) => {
        const successBoxesItem = {
            image: $scope.getImageUrl() + element.name + $scope.getImageExtension(),
            url: element.url
        };
        return successBoxesItem;
    };

    /**
     * Set link with appropriate breakpoint code and perform AJAX get request.
     * On success call setSuccessBoxesList.
     * @param {string} breakpoint Name of current breakpoint
     */
    $scope.getSuccessBoxes = (breakpoint) => {
        $scope.setLink($scope.getCurrentBreakpoint(breakpoint));

        const box = angular.element(document.getElementsByClassName('rp-successBoxes'));

        if (breakpoint === 'narrow' || breakpoint === 'extraNarrow') {
            $timeout(() => {
                box[0].style.display = 'none';
                box[1].style.display = '';
                box[1].style.margin = '0 auto 16px';
            }, 0);
        } else {
            $timeout(() => {
                box[0].style.display = '';
                box[1].style.display = 'none';
            }, 0);
        }

        $http.get($scope.getLink()).success((data) => {
            if (Array.isArray(data)) {
                $scope.setSuccessBoxesList($scope.formatUrl(data));
            }
        });
    };

    /**
     * Get success boxes and register listener for "breakpointChanged" event
     */
    $scope.init = () => {
        $scope.getSuccessBoxes(CommonFunctions.getScreenSize());

        $scope.$on('breakpointChanged', (event, data) => {
            $scope.getSuccessBoxes(data);
        });
    };
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveSuccessBoxes.js